<template>
  <div>
    <the-nav-bar :title="$t('createPost.location')" />
    <div class="body-wrapper">
      <div class="radio-panel">
        <div class="panel-title"></div>
        <div class="radio-group">
          <md-radio-box v-model="location" name="shenzhen">
            <md-icon name="location"></md-icon>
            <span>Shenzhen,CN</span>
          </md-radio-box>
          <md-radio-box v-model="location" name="guangzhou">
            <md-icon name="location"></md-icon>
            <span>Guangzhou,CN</span>
          </md-radio-box>
        </div>
      </div>
      <div class="input-panel">
        <div class="panel-title"></div>
        <div class="input-group"></div>
      </div>
      <div class="btn-group">
        <md-button type="primary">
          <span>{{ $t('common.confirm') }}</span>
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import { RadioBox, InputItem, Button, Icon } from 'mand-mobile';
export default {
  components: {
    'the-nav-bar': TheNavBar,
    [RadioBox.name]: RadioBox,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },
  data() {
    return {
      location: '',
    };
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding: 9.6vw 4.8vw 30vw;
}
</style>
